<template>
  <AppTooltip :location="location" :max-width="maxWidth">
    <template v-slot:activator="{ props }">
      <v-icon v-bind="props" :icon="icon" :size="size" :color="color" :class="iconClass" />
    </template>
    <slot>{{ text }}</slot>
  </AppTooltip>
</template>

<script>
/**
 * The recurring "small icon that shows a tooltip on hover" pattern (notes
 * icons, info hints, warning markers) - one place to change how that whole
 * family of hints looks/behaves.
 */
export default {
  name: 'IconTooltip',

  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'grey'
    },
    size: {
      type: String,
      default: 'small'
    },
    location: {
      type: String,
      default: 'top'
    },
    maxWidth: {
      type: [String, Number],
      default: 320
    },
    iconClass: {
      type: String,
      default: undefined
    }
  }
};
</script>
